module.exports = __webpack_public_path__ + "static/build-e32fe19d2f091e5b1613ff8e3c0c43ae.svg";